type GetAddressFormattedProps = {
    addressParts: {
        address: string;
        number: string;
        complement?: string;
        neighborhood?: string;
        cityName?: string;
        stateAbbr?: string;
        zipCode?: string;
    };
};

export function getAddressFormatted({ addressParts }: GetAddressFormattedProps) {
    if (!addressParts?.address) {
        return "";
    }

    let address = `${addressParts.address}, ${addressParts.number}`;

    if (addressParts.complement) {
        address = `${address} - ${addressParts.complement}`;
    }

    if (addressParts.zipCode) {
        address = `${address} - ${addressParts.zipCode}`;
    }

    if (addressParts.neighborhood) {
        address = `${address}, ${addressParts.neighborhood}`;
    }

    if (addressParts.cityName && addressParts.stateAbbr) {
        address = addressParts.stateAbbr
            ? `${address} - ${addressParts.cityName}/${addressParts.stateAbbr}`
            : `${address} - ${addressParts.cityName}`;
    }

    if (!addressParts.cityName && addressParts.stateAbbr) {
        address = `${address} - ${addressParts.stateAbbr}`;
    }

    return address;
}
